export default {
  form: {
    header: {
      label: 'Koptekst',
      placeholder: 'Koptekst',
    },
    sub_header: {
      label: 'Subkoptekst',
      placeholder: 'Subkoptekst',
    },
    description: {
      label: 'Beschrijving',
      placeholder: 'Beschrijving',
    },
    qr_code_header: {
      label: 'UI-box koptekst',
      placeholder: 'UI-box koptekst',
    },
    qr_code_description: {
      label: 'UI-box beschrijving',
      placeholder: 'UI-box beschrijving',
    },
    footer: {
      label: 'Voettekst',
      placeholder: 'Voettekst invoeren',
    },
    url_type: {
      label: 'URL',
      placeholder: 'URL selecteren',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Primaire kleur',
    },
    background_color: {
      label: 'Achtergrondkleur',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Flyer laden mislukt',
  },
};
